import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    },
    validateStatus: (status) => {
        return true;
    },
});

export const fileUploadApi = (data, setProgress) =>
    api({
        url: "/files",
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data,
        onUploadProgress: (event) => {
            setProgress(Math.round((event.loaded / event.total / 2) * 100));
        },
    });

export const attachmentUploadApi = (data, setProgress) =>
    api({
        url: "/attachments",
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data,
        onUploadProgress: (event) => {
            setProgress(Math.round((event.loaded / event.total / 2) * 100));
        },
    });

export const imageUploadApi = (data, setProgress) =>
    api({
        url: `/images`,
        method: "POST",
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data,
        onUploadProgress: (event) => {
            setProgress(Math.round((event.loaded / event.total / 2) * 100));
        },
    });

export default api;
